export const ABSOLUTE_DEMAND_TABLE_VALUE = 'absoluteDemandTable';
